import './ShortInfo.css';
import React from 'react';
import type { Node } from 'react';

export default (props: { children: Node }) => <div className="short-info">{props.children}</div>;
